import { apiV2 } from '@/libs/axios/axios'

export const useStripeApi = () => {
  // change api base url default
  const createCheckoutSession = async ({ priceId, metadata }) => {
    const { data } = await apiV2.post('/stripe/create-checkout-session', {
      priceId,
      metadata: {
        ...metadata,
        source: 'daai-web',
        version: app.version,
      },
    })
    return data
  }

  const createPortalSession = async () => {
    const { data } = await apiV2.post('/stripe/create-portal-session')
    return data
  }

  return {
    createCheckoutSession,
    createPortalSession,
  }
}
